/**
 * Турецкий набор строк.
 */

import type { Strings } from './index';

export const tr: Strings = {
  login_title: 'CargoPASS oturumu açma',
  login_phone_label: 'Telefon numarası',
  login_code_request: 'Kod al',
  login_code_label: 'Mesajdaki kod',
  login_code_submit: 'Giriş yap',
  login_failed: 'Giriş yapılamadı. Lütfen yeniden deneyin.',
  works_title: 'İşler',
  works_more: 'Daha fazla göster',
  works_failed: 'Liste yüklenemedi.',

  // Ключи блока `WEB-1.1`: оболочка кабинета, четыре состояния экрана, вторая
  // ветка входа и согласие с условиями. Юридического текста условий здесь нет
  // ни в одном виде — его пишет человек, а временная строка была бы заглушкой.
  login_channel_phone: 'Telefon ile',
  login_channel_email: 'E-posta ile',
  login_email_label: 'E-posta adresi',
  login_terms_label: 'Kullanım koşullarını kabul ediyorum',
  company_switcher_label: 'Şirket',
  language_label: 'Dil',
  state_loading: 'Yükleniyor…',
  state_empty: 'Henüz bir şey yok',
  state_error: 'Veriler alınamadı',
  state_no_access: 'Bu sayfa size açık değil',
  no_membership_title: 'Hiçbir firmaya bağlı değilsiniz',
  no_membership_explain: 'Çalışmaya başlamak için bir firmaya katılın ya da kendi firmanızı açın.',
  company_create_submit: 'Firma oluştur',
  company_name_label: 'Firma adı',
  company_form_type_label: 'Firma türü',
  company_tax_id_label: 'Kayıt numarası',
  company_legal_address_label: 'Yasal adres',
  company_members_title: 'Firma çalışanları',
  not_found_title: 'Böyle bir sayfa yok',

  // Ключи блока `WEB-1.2`: профиль пользователя, сотрудники, права, профиль
  // фирмы и документы. Подписи значений перечней собираются строителями ключа
  // из значения, пришедшего с сервера, и потому на экране литералом не стоят.
  profile_title: 'Profilim',
  profile_sessions_title: 'Etkin oturumlar',
  profile_session_current: 'Geçerli oturum',
  profile_session_never_used: 'Hiç kullanılmadı',
  profile_session_created: 'Oluşturuldu',
  profile_session_last_used: 'Son giriş',
  profile_session_terminate: 'Sonlandır',
  profile_channel_add: 'İletişim kanalı ekle',
  profile_channel_code_request: 'Kodu gönder',
  profile_channel_confirm: 'Kanalı doğrula',
  members_title: 'Çalışanlar',
  members_invite: 'Çalışan davet et',
  invite_channel_phone: 'Telefonla',
  invite_channel_email: 'E-postayla',
  invite_role_label: 'Rol',
  invite_submit: 'Daveti gönder',
  invitations_title: 'Davetler',
  invitation_revoke: 'Geri al',
  invitation_resend: 'Yeniden gönder',
  rights_title: 'Çalışan hakları',
  rights_grants: 'Rolün üstüne verilen',
  rights_denies: 'Kişisel olarak yasaklanan',
  rights_grant_add: 'Hak ver',
  rights_deny_add: 'Yasak koy',
  rights_remove: 'Kaldır',
  company_profile_title: 'Firma profili',
  company_documents_title: 'Firma belgeleri',
  company_type_transport: 'Taşıyıcı',
  company_type_logistics: 'Lojistik firması',
  member_documents_title: 'Çalışan belgeleri',
  document_download: 'Dosyayı aç',
  enum_unknown: 'Bilinmiyor',
  role_director: 'Direktör',
  role_logist: 'Lojistikçi',
  role_dispatcher: 'Sevkiyatçı',
  role_accountant: 'Muhasebeci',
  role_mechanic: 'Makinist',
  role_driver: 'Sürücü',
  member_status_active: 'Geçerli',
  member_status_closed: 'Kapalı',
  permission_company_staff_manage: 'Çalışanları yönet',
  permission_company_rights_manage: 'Hakları yönet',
  permission_company_fleet_manage: 'Filoyu yönet',
  permission_company_fleet_repair: 'Onarımı işaretle',
  permission_company_docs_manage: 'Belgeleri yönet',
  permission_company_listings_manage: 'İlanları yönet',
  permission_company_cargo_take: 'Yük alma',
  // РОСТ 0.9.30 (BE-2.4, шаг CONTRACT; решение D525): восьмое право каталога — привязка транспорта и водителя.
  permission_company_works_assign: 'Araç ve sürücü atama',
  permission_company_accounting_manage: 'Şirket gider ve ödemelerini yönetme',
  document_status_pending: 'İncelemede',
  document_status_verified: 'Doğrulandı',
  document_status_rejected: 'Reddedildi',
  document_status_expired: 'Süresi doldu',
  document_status_not_verified: 'Doğrulanmadı',
  invitation_status_pending: 'Yanıt bekliyor',
  invitation_status_accepted: 'Kabul edildi',
  invitation_status_revoked: 'İptal edildi',
  invitation_status_expired: 'Süresi doldu',

  // Блок `WEB-1.3`. До волны 4 — машинный подстрочник (CR-008): присутствие и
  // непустота обязательны, содержимое проверке не подлежит.
  fleet_title: 'Şirket filosu',
  fleet_add: 'Araç ekle',
  fleet_added: 'Araç eklendi',
  fleet_add_already: 'Bu araç zaten kayıtlı',
  fleet_vin: 'VIN numarası',
  fleet_tech_passport: 'Teknik pasaport numarası',
  fleet_kind_label: 'Araç türü',
  fleet_body_type_label: 'Kasa tipi',
  fleet_withdraw: 'Kayıttan çıkar',
  fleet_withdrawn_at: 'Çıkarılma tarihi',
  fleet_empty: 'Kayıt şimdilik boş',
  service_title: 'Araç servisi',
  service_state_label: 'Teknik durum',
  service_state_change: 'Durumu değiştir',
  service_records_title: 'İş günlüğü',
  service_record_add: 'Kayıt ekle',
  service_description: 'Ne yapıldı, hangi üniteler',
  service_parts: 'Yedek parçalar',
  service_cost: 'Gider',
  service_currency: 'Para birimi',
  service_records_empty: 'Henüz kayıt yok',
  vin_claims_title: 'VIN serbest bırakma başvuruları',
  vin_claim_create: 'Başvuru yap',
  vin_claim_object: 'İtiraz et',
  vin_claim_window_ends_at: 'İtiraz penceresi bitişi',
  vin_claims_empty: 'Henüz başvuru yok',
  vehicle_kind_tractor: 'Çekici',
  vehicle_kind_trailer: 'Römork',
  body_type_tarpaulin: 'Tenteli kasa',
  body_type_refrigerator: 'Frigorifik kasa',
  body_type_isothermal: 'İzotermik kasa',
  body_type_box: 'Kapalı kasa',
  body_type_flatbed: 'Açık kasa',
  body_type_platform: 'Platform kasa',
  body_type_lowbed: 'Lowbed kasa',
  body_type_mega: 'Mega kasa',
  body_type_car_carrier: 'Oto taşıyıcı kasa',
  body_type_tipper: 'Damperli kasa',
  body_type_walking_floor: 'Yürüyen tabanlı kasa',
  body_type_tank: 'Tanker kasa',
  body_type_silo: 'Silobas kasa',
  body_type_container_chassis: 'Konteyner şasisi',
  body_type_bdf: 'BDF kasa',
  body_type_timber: 'Tomruk kasası',
  body_type_livestock: 'Canlı hayvan kasası',
  body_type_coil: 'Rulo kasası',
  body_type_heavy_haul: 'Ağır nakliye kasası',
  body_type_extendable: 'Uzayabilir kasa',
  repair_state_fault_detected: 'Arıza tespit edildi',
  repair_state_in_repair: 'Tamirde',
  repair_state_repaired: 'Tamir edildi',
  repair_state_ready: 'Çalışmaya hazır',
  vehicle_status_active: 'Kayıtta',
  vehicle_status_withdrawn: 'Kayıttan çıkarıldı',
  vin_claim_status_pending: 'İtiraz penceresi açık',
  vin_claim_status_objected: 'İtiraz edildi',
  vin_claim_status_awaiting_admin: 'Personel kararı bekleniyor',
  vin_claim_direction_outgoing: 'Bizim başvurumuz',
  vin_claim_direction_incoming: 'Bize gelen başvuru',

  // Ключи блока `WEB-3.2` — страница публичного отслеживания по ссылке с PIN
  // (словарь §11 спецификации блока) и подписи двух перечней контракта.
  tracking_title: 'Araç transferi takibi',
  tracking_pin_hint: 'Müşterinin bağlantıyla birlikte verdiği altı haneli PIN kodunu girin. PIN olmadan sayfa hiçbir şey göstermez.',
  tracking_pin_label: 'Altı haneli PIN',
  tracking_pin_submit: 'Aç',
  tracking_offline: 'Bağlantı yok. İnterneti kontrol edip tekrar deneyin.',
  tracking_offline_refresh: 'Bağlantı yok — bağlantı geri geldiğinde yenilenecek.',
  tracking_status_changed_at: 'Durum değişti',
  tracking_vehicle: 'Araç',
  tracking_route: 'Güzergâh',
  tracking_distance: 'Mesafe',
  tracking_transit: 'Transit',
  tracking_border_crossings: 'Sınır geçişi sayısı',
  tracking_last_position: 'Son konum',
  tracking_no_position: 'Konum henüz alınmadı',
  tracking_open_map: 'Haritada aç',
  tracking_photos: 'Araç teslim alımı',
  tracking_photo_open: 'Fotoğrafı aç',
  tracking_photo_plate: 'Plaka',
  tracking_photo_close: 'Kapat',
  tracking_milestones: 'Aşamalar',
  tracking_locked_title: 'Bağlantı geçici olarak kullanılamıyor',
  tracking_retry: 'PIN\'i yeniden gir',
  tracking_gone_title: 'Bağlantı artık geçerli değil',
  tracking_map_title: 'Harita: son konum',
  work_status_CREATED: 'Oluşturuldu',
  work_status_ASSIGNED: 'Atandı',
  work_status_ACCEPTED: 'İcraya kabul edildi',
  work_status_AT_PICKUP: 'Yüklemede',
  work_status_AT_HANDOVER: 'Araç teslim alımı',
  work_status_IN_TRANSIT: 'Yolda',
  work_status_DELIVERED: 'Teslim edildi',
  work_status_COMPLETED: 'Tamamlandı',
  work_status_CANCELLED: 'İptal edildi',
  work_status_ARCHIVED: 'Arşivde',
  peregon_vehicle_kind_tractor: 'Çekici',
  peregon_vehicle_kind_tractor_with_trailer: 'Römorklu çekici',
  peregon_vehicle_kind_car: 'Binek otomobil',

  // Ключи блока `WEB-2.1` — кабинет логиста: «Мои объявления», форма
  // объявления, карточка с offer'ами и доской заказа (словарь §11
  // спецификации блока) и подписи девяти перечней контракта.
  // До волны 4 значения этого языка — подстрочник (CR-008).
  cargo_listings_title: 'Yük ilanları',
  cargo_listings_create: 'İlan oluştur',
  cargo_listings_more: 'Daha fazla göster',
  cargo_listings_empty: 'Henüz ilan yok',
  cargo_listing_edit: 'Düzenle',
  cargo_listing_close: 'Kapat',
  cargo_listing_close_confirm: 'İlan kapatılsın mı? Kapatılan ilan akışa dönmez.',
  cargo_listing_km: 'km',
  cargo_listing_kg: 'kg',
  cargo_listing_days: 'gün',
  cargo_listing_transit: 'Transit',
  cargo_listing_borders: 'Sınır geçişleri',
  cargo_listing_slots_free: 'Boş',
  cargo_listing_slots_of: 'toplam',
  cargo_listing_fixed: 'Sabit fiyat',
  cargo_listing_payment: 'Ödeme',
  cargo_listing_form_title_new: 'Yeni yük ilanı',
  cargo_listing_form_title_edit: 'Yük ilanını düzenle',
  cargo_listing_form_origin: 'Yükleme şehri',
  cargo_listing_form_destination: 'Boşaltma şehri',
  cargo_listing_form_city_search: 'Şehir adını yazmaya başlayın',
  cargo_listing_form_loading_at: 'Yükleme tarihi',
  cargo_listing_form_unload_by: 'Son boşaltma tarihi',
  cargo_listing_form_vehicles_count: 'Gereken araç sayısı',
  cargo_listing_form_cargo_type: 'Yük',
  cargo_listing_form_weight: 'Araç başına ağırlık, kg',
  cargo_listing_form_adr: 'Tehlikeli yük (ADR)',
  cargo_listing_form_body_type: 'Kasa tipi',
  cargo_listing_form_body_subtype: 'Kasa alt tipi',
  cargo_listing_form_temperature_from: 'en az',
  cargo_listing_form_temperature_to: 'en çok',
  cargo_listing_form_price: 'Araç başına fiyat',
  cargo_listing_form_currency: 'Para birimi',
  cargo_listing_form_negotiable: 'Pazarlık olur',
  cargo_listing_form_payment_method: 'Ödeme şekli',
  cargo_listing_form_payment_moment: 'Ödeme zamanı',
  cargo_listing_form_deferral_days: 'Vade günü',
  cargo_listing_form_comment: 'Yorum',
  cargo_listing_form_submit: 'Yayınla',
  cargo_listing_form_save: 'Değişiklikleri kaydet',
  cargo_offers_title: 'Taşıyıcı teklifleri',
  cargo_offer_accept: 'Onayla',
  cargo_offer_decline: 'Reddet',
  cargo_offer_decline_confirm: 'Teklif reddedilsin mi? Taşıyıcı reddi görecek.',
  cargo_offer_agrees: 'Koşullarınızı kabul ediyor',
  cargo_offer_counter: 'Kendi fiyatını öneriyor',
  cargo_offer_documents_verified: 'Belgeleri doğrulandı',
  cargo_offer_vehicles: 'Araç',
  cargo_offer_price: 'Taşıyıcı fiyatı',
  cargo_offer_listing_price: 'İlan fiyatı',
  cargo_offer_expires: 'Yanıt süresi',
  cargo_offer_more: 'Daha fazla teklif',
  cargo_slots_title: 'Sipariş panosu',
  cargo_slot_work: 'İş',
  listing_status_OPEN: 'Açık',
  listing_status_TAKEN: 'Tüm araçlar bulundu',
  listing_status_CLOSED: 'Kapalı',
  listing_status_CANCELLED: 'İptal edildi',
  listing_status_PENDING_REVIEW: 'İncelemede',
  listing_status_REJECTED: 'Reddedildi',
  cargo_offer_status_PENDING: 'Karar bekleniyor',
  cargo_offer_status_APPROVED: 'Onaylandı — taşıyıcı onayı bekleniyor',
  cargo_offer_status_CONFIRMED: 'Taşıyıcı onayladı',
  cargo_offer_status_REJECTED: 'Reddedildi',
  cargo_offer_status_WITHDRAWN: 'Taşıyıcı geri çekti',
  cargo_offer_status_EXPIRED: 'Süresi doldu',
  cargo_offer_status_SUPERSEDED: 'Boş araç kalmadı',
  cargo_offer_status_CANCELLED: 'Tüm işler iptal edildi',
  cargo_slot_status_OPEN: 'Boş',
  cargo_slot_status_RESERVED: 'Taşıyıcı onayı bekleniyor',
  cargo_slot_status_TAKEN: 'Dolu',
  cargo_slot_status_CANCELLED: 'İptal edildi',
  currency_USD: 'USD ($)',
  currency_UZS: 'UZS (som)',
  currency_EUR: 'EUR (€)',
  payment_method_cash: 'Nakit',
  payment_method_bank_transfer: 'Banka havalesi',
  payment_moment_prepayment: 'Peşin',
  payment_moment_on_unloading: 'Boşaltmada',
  payment_moment_deferred: 'Vadeli',
  loading_type_rear: 'Arkadan',
  loading_type_side: 'Yandan',
  loading_type_top: 'Üstten',
  loading_type_full_uncover: 'Tam açık',
  body_parameter_length_m: 'Uzunluk, m',
  body_parameter_width_m: 'Genişlik, m',
  body_parameter_height_m: 'Yükseklik, m',
  body_parameter_volume_m3: 'Hacim, m³',
  body_parameter_capacity_t: 'Taşıma kapasitesi, t',
  body_parameter_loading_type: 'Yükleme tipi',
  body_parameter_temperature: 'Sıcaklık, °C',
  body_parameter_cars_capacity: 'Araç kapasitesi',

  // Ключи блока `WEB-2.2`. Машинный подстрочник до волны 4 (CR-008): проверке
  // не подлежит, обязательны присутствие ключа и непустота значения.
  cargo_feed_title: 'Yük akışı',
  cargo_feed_filters: 'Filtreler',
  cargo_feed_apply: 'Uygula',
  cargo_feed_reset: 'Sıfırla',
  cargo_feed_more: 'Daha fazla göster',
  cargo_feed_details: 'Ayrıntılar',
  cargo_feed_company_verified: 'Firma doğrulandı',
  cargo_feed_adr: 'Tehlikeli yük (ADR)',
  cargo_feed_empty: 'Uygun ilan yok',
  cargo_feed_loading_from: 'Yükleme başlangıcı',
  cargo_feed_loading_to: 'Yükleme bitişi',
  cargo_feed_vehicles_min: 'En az araç',
  cargo_feed_weight_from: 'Ağırlık en az, kg',
  cargo_feed_weight_to: 'Ağırlık en çok, kg',
  cargo_feed_body_type: 'Kasa tipi',
  cargo_feed_temperature: 'Sıcaklık kontrolü',
  cargo_feed_price_from: 'Araç başı fiyat en az',
  cargo_feed_price_to: 'Araç başı fiyat en çok',
  cargo_feed_currency: 'Fiyat para birimi',
  cargo_feed_q: 'Anahtar kelime',
  cargo_feed_any: 'Fark etmez',
  cargo_feed_yes: 'Evet',
  cargo_feed_no: 'Hayır',
  cargo_feed_cities_title: 'Çıkış şehirleri',
  cargo_feed_cities_total: 'Toplam ilan',
  cargo_feed_date_hint: 'YYYY-AA-GG',
  cargo_feed_my_offer: 'Firmanızın teklifi',
  cargo_feed_listing_no_right: 'Teklifi yük alma yetkisi olan çalışan gönderebilir — yetkiyi müdür verir',
  cargo_feed_listing_unavailable: 'Bu firmadan bu ilana şu anda teklif gönderilemez',
  cargo_feed_listing_agree: 'Şartlarınızı kabul ediyorum',
  cargo_feed_listing_own_price: 'Kendi fiyatım',
  cargo_feed_listing_fixed_price: 'Fiyat sabit',
  cargo_feed_listing_negotiable: 'Pazarlık yapılabilir',
  cargo_feed_listing_submit: 'Teklif gönder',
  cargo_feed_listing_price_amount: 'Araç başı fiyatınız',
  cargo_offers_mine_title: 'Tekliflerim',
  cargo_offers_confirm: 'Onayla',
  cargo_offers_withdraw: 'Geri çek',
  cargo_offers_withdraw_confirm: 'Teklif geri çekilsin mi? Lojistikçi artık değerlendirmeyecek.',
  cargo_offers_more: 'Daha fazla teklif göster',
  cargo_offers_agrees: 'Şartlar kabul',
  cargo_offers_counter: 'Kendi fiyatı',
  cargo_offers_vehicles: 'Araç',
  cargo_offers_empty: 'Henüz teklif yok',
  cargo_offers_price: 'Araç başı fiyat',
  cargo_offers_expires: 'Lojistikçi yanıtı son tarih',
  cargo_offers_confirm_by: 'Son onay tarihi',
  cargo_offers_sender: 'Gönderen',
  works_to_assign_title: 'Atama bekleyenler',
  works_to_assign_empty: 'Atama bekleyen iş yok',
  works_empty: 'Henüz iş yok',
  works_assign: 'Ata',
  works_replace: 'Değiştir',
  work_assignment_title: 'Araç ve sürücü ataması',
  work_assignment_tractor: 'Çekici',
  work_assignment_trailer: 'Römork',
  work_assignment_driver: 'Sürücü',
  work_assignment_no_trailer: 'Römorksuz',
  work_assignment_driver_busy: 'Meşgul',
  work_assignment_unnamed: 'Ad belirtilmemiş',
  work_assignment_assign: 'Ata',
  work_assignment_replace: 'Değiştir',
  work_assignment_current: 'Şu an atanmış',
  work_assignment_assigned_at: 'Atanma zamanı',
  work_assignment_history: 'Atama geçmişi',
  work_assignment_history_empty: 'Değişiklik olmadı',
  work_assignment_assigned_by: 'Atayan',
  work_assignment_replaced_by: 'Kaldıran',
  work_assignment_unavailable: 'Bu iş için atama ve değiştirme şu anda yapılamaz',
  unassignable_reason_withdrawn: 'Kayıttan çıkarıldı',
  unassignable_reason_not_ready: 'Sefere hazır değil',
  unassignable_reason_busy: 'Başka bir işte',

  // Ключи блока `WEB-2.4`: карточка машины, водители фирмы, строки запчастей,
  // файл техпаспорта заявки, дата рождения и пол; подписи пола и типа документа.
  // До волны 4 — подстрочник (CR-008): проверке не подлежит.
  vehicle_card_title: 'Araç kartı',
  vehicle_photo_title: 'Araç fotoğrafları',
  vehicle_photo_file: 'Fotoğraf seçin',
  vehicle_photo_add: 'Fotoğraf ekle',
  vehicle_photo_delete: 'Sil',
  vehicle_photo_delete_confirm: 'Bu araç fotoğrafı silinsin mi?',
  vehicle_photo_empty: 'Henüz fotoğraf yok',
  vehicle_fault_title: 'Açık arızalar',
  vehicle_fault_empty: 'Açık arıza yok',
  vehicle_fault_author_unknown: 'Yazar belirtilmemiş',
  vehicle_fault_comment: 'Araçta sorun ne',
  vehicle_fault_photos: 'Arıza fotoğrafları',
  vehicle_fault_add: 'Arıza kaydet',
  vehicle_fault_history: 'Tüm arızalar',
  vehicle_fault_open: 'Açık',
  vehicle_fault_closed: 'Kapalı',
  vehicle_fault_history_empty: 'Araçta hiç arıza olmadı',
  drivers_title: 'Firma sürücüleri',
  drivers_age: 'Yaş:',
  drivers_name_unknown: 'Ad belirtilmemiş',
  drivers_not_specified: 'belirtilmemiş',
  drivers_self_reported: 'Ad, yaş ve cinsiyet kişinin kendi beyanıdır',
  drivers_documents: 'Belgeler',
  drivers_empty: 'Henüz sürücü yok',
  service_part_add: 'Satır ekle',
  service_part_remove: 'Kaldır',
  service_part_name: 'Parça adı',
  service_part_quantity: 'Adet',
  vin_claim_file_label: 'Ruhsat dosyası — fotoğraf veya PDF',
  vin_claim_file_link: 'Ruhsat',
  vin_claim_file_missing: 'Dosyasız gönderildi',
  profile_birth_date: 'Doğum tarihi',
  profile_gender: 'Cinsiyet',
  profile_gender_unspecified: 'Belirtilmemiş',
  profile_personal_note: 'Kişinin kendi beyanı',
  profile_personal_hint: 'Size görünür; firma üyelerine yalnızca yaş ve cinsiyet',
  profile_personal_save: 'Kaydet',
  gender_male: 'Erkek',
  gender_female: 'Kadın',
  document_type_passport: 'Pasaport',
  document_type_driver_license: 'Sürücü belgesi',
  document_type_adr_certificate: 'ADR belgesi',
  document_type_professional_certificate: 'Mesleki yeterlilik belgesi',
  document_type_face_snapshot: 'Yüz fotoğrafı',
  document_type_tachograph_card: 'Takograf kartı',
  document_type_code95_card: 'Kod 95 kartı',
  document_type_visa: 'Vize',
  document_type_registration_certificate: 'Tescil belgesi',
  expenses_title: 'Giderler',
  expenses_create: 'Gider kaydet',
  expenses_delete_confirm: 'Bu gider silinsin mi?',
  expenses_empty: 'Henüz gider yok',
  expense_form_submit: 'Gideri kaydet',
  expense_form_category: 'Kategori',
  expense_form_spent_on: 'Gider tarihi',
  expense_form_vehicle: 'Araç',
  expense_form_receipt: 'Fiş — fotoğraf veya PDF',
  expense_receipt_refreshed: 'Fiş bağlantısı yenilendi — yeniden açın',
  expense_receipt_replace_hint: 'yeni dosya öncekinin yerini alır',
  payouts_title: 'Ödemeler',
  payouts_create: 'Ödeme kaydet',
  payouts_delete_confirm: 'Bu ödeme silinsin mi?',
  payouts_empty: 'Henüz ödeme yok',
  payout_form_submit: 'Ödemeyi kaydet',
  payout_form_recipient: 'Alıcı',
  payout_form_paid_on: 'Ödeme tarihi',
  payout_recipient_unnamed: 'Ad belirtilmemiş',
  payout_recipient_not_listed: 'Firma sürücüleri listesinde yok',
  payout_recipient_unavailable: 'Alıcı adı kullanılamıyor',
  payout_recipient_loading: 'Alıcı yükleniyor…',
  accounting_edit: 'Değiştir',
  accounting_delete: 'Sil',
  accounting_more: 'Daha fazla göster',
  accounting_works_more: 'Daha fazla iş göster',
  accounting_filter_reset: 'Sıfırla',
  accounting_filter_empty: 'Bu filtreye uygun kayıt yok',
  accounting_filter_any: 'Tümü',
  accounting_work_fallback: 'İş',
  accounting_vehicle_fallback: 'Araç',
  accounting_vehicle_missing: 'Araç kayıtta bulunamadı',
  accounting_no_vehicle: 'Araçsız',
  accounting_no_work: 'İşe bağlı değil',
  accounting_field_amount: 'Tutar',
  accounting_field_currency: 'Para birimi',
  accounting_field_work: 'İş',
  accounting_field_comment: 'Yorum',
  accounting_choose: 'Seçin',
  accounting_form_close: 'Vazgeç',
  expense_category_diesel: 'Dizel yakıt',
  expense_category_parking: 'Otopark',
  expense_category_toll: 'Ücretli yol',
  expense_category_service: 'Bakım ve onarım',
  expense_category_other: 'Diğer',
  state_retry: 'Yeniden dene',
  member_unnamed: 'Ad belirtilmemiş',
  work_card_not_available: 'İş kullanılamıyor',
  work_card_status: 'Durum',
  work_card_price: 'Fiyat',
  work_card_vehicle: 'Araç',
  work_card_vehicle_model: 'Model',
  work_card_auto_completed: 'Otomatik tamamlandı',
  work_card_confirm: 'Teslimatı onayla',
  work_card_confirm_question: 'Teslimat onaylansın mı? İş tamamlanacak.',
  work_card_confirm_by: 'Son onay',
  work_card_verified: 'Belgeler doğrulandı',
  work_card_not_verified: 'Belgeler doğrulanmadı',
  work_card_parties: 'Taraflar',
  work_card_customer: 'Müşteri',
  work_card_executor: 'Yüklenici',
  work_card_assignment: 'Araç ve sürücü',
  work_card_assignment_empty: 'Araç ve sürücü henüz atanmadı',
  work_card_cargo: 'Yük',
  work_card_cargo_type: 'Yük türü',
  work_card_cargo_loading: 'Yükleme tarihi',
  work_card_cargo_weight: 'Ağırlık',
  work_card_cargo_body: 'Kasa',
  work_card_history: 'Geçmiş',
  work_card_history_empty: 'Henüz geçmiş yok',
  work_card_track: 'Rota izi',
  work_card_track_empty: 'Henüz rota noktası yok',
  work_card_track_thinned: 'Rota seyreltildi: tüm noktalar gösterilmiyor',
  work_card_track_signal: 'Sinyal',
  work_card_track_age: 'Son nokta',
  work_card_track_minutes: 'dk önce',
  work_card_tiles_failed: 'Harita altlığı kullanılamıyor; rota çizgisi onsuz gösteriliyor',
  work_card_chat: 'İş sohbeti',
  work_card_message_text: 'Mesaj',
  work_card_message_photo: 'Fotoğraf',
  work_card_message_send: 'Gönder',
  work_card_message_hidden: 'Mesaj gizlendi',
  work_card_messages_more: 'Öncekileri göster',
  work_card_messages_empty: 'Henüz mesaj yok',
  work_card_thread: 'Sürücü yazışması',
  work_card_thread_caption: 'Müdür ve sevkiyatçı',
  work_card_thread_open: 'Yazışmayı aç',
  work_card_files: 'Belgeler ve fişler',
  work_card_files_empty: 'Henüz dosya yok',
  work_card_file_kind: 'Dosya türü',
  work_card_file_description: 'Açıklama',
  work_card_file_choose: 'Dosya — fotoğraf veya PDF',
  work_card_file_uploaded: 'Dosya yüklendi',
  work_card_file_edit: 'Açıklamayı düzenle',
  work_card_file_save: 'Kaydet',
  work_card_file_delete: 'Sil',
  work_card_file_delete_question: 'Bu dosya silinsin mi?',
  work_card_photos: 'İş fotoğrafları',
  work_card_photos_empty: 'Henüz fotoğraf yok',
  work_card_photo_plate: 'Plaka karesi',
  work_card_tracking: 'Takip bağlantısı',
  work_card_tracking_create: 'Bağlantı oluştur',
  work_card_tracking_revoke: 'Bağlantıyı iptal et',
  work_card_tracking_revoke_question: 'Bağlantı iptal edilsin mi? Hemen çalışmaz olur.',
  work_card_tracking_revoked: 'Bağlantı iptal edildi',
  work_card_tracking_copy: 'Kopyala',
  work_card_tracking_copied: 'Kopyalandı',
  work_card_tracking_url: 'Adres',
  work_card_tracking_pin: 'PIN',
  work_card_tracking_once: 'Bir kez gösterilir: şimdi kaydedin. Yeni bağlantı eskisinin yerini alır.',
  work_card_rating: 'Puan',
  work_card_rating_score: '1-5 arası puan',
  work_card_rating_comment: 'Yorum',
  work_card_rating_send: 'Puan ver',
  work_card_rating_later: 'Sonra',
  work_card_rating_late: 'Süre sonrası puanlandı',
  work_card_claims: 'İptal ve anlaşmazlık',
  work_card_cancel_request: 'İptal iste',
  work_card_cancel_category: 'Kategori',
  work_card_cancel_reason: 'Neden',
  work_card_cancel_send: 'İsteği gönder',
  work_card_cancel_respond_by: 'Son yanıt',
  work_card_cancel_accept: 'İptali kabul et',
  work_card_cancel_accept_question: 'İptal kabul edilsin mi? İş iptal edilecek.',
  work_card_cancel_decline: 'Reddet',
  work_card_cancel_withdraw: 'İsteği geri çek',
  work_card_dispute: 'Anlaşmazlık',
  work_card_dispute_open: 'Anlaşmazlık aç',
  work_card_dispute_statement: 'Beyan',
  work_card_dispute_send: 'Beyanı gönder',
  work_card_dispute_outcome: 'Sonuç',
  work_card_dispute_guilty: 'Kusurlu taraf',
  work_card_dispute_note: 'Personel kararı',
  work_card_dispute_message: 'Anlaşmazlığa mesaj',
  work_card_dispute_message_send: 'Mesaj ekle',
  work_signal_OK: 'Sinyal var',
  work_signal_NO_DATA: 'Uzun süredir veri yok',
  work_signal_LOST: 'Sinyal kayboldu',
  work_file_kind_document: 'Belge',
  work_file_kind_receipt: 'Fiş',
  work_file_kind_cmr: 'CMR',
  work_photo_phase_handover: 'Araç teslim alma',
  work_photo_phase_delivery: 'Teslim',
  work_photo_phase_loading: 'Yükleme',
  work_photo_phase_unloading: 'Boşaltma',
  cancellation_category_VEHICLE_BREAKDOWN: 'Araç arızası',
  cancellation_category_ACCIDENT: 'Kaza',
  cancellation_category_OWNER_DEMAND: 'Sahibin talebi',
  cancellation_category_DOCUMENTS_OR_BORDER: 'Belgeler veya sınır',
  cancellation_category_EXECUTOR_FORCE_MAJEURE: 'Yüklenici mücbir sebebi',
  cancellation_category_CARGO_WITHDRAWN: 'Yük geri çekildi',
  cancellation_category_CARGO_NOT_READY: 'Yük hazır değil',
  cancellation_category_OTHER: 'Diğer',
  cancellation_request_status_REQUESTED: 'Yanıt bekleniyor',
  cancellation_request_status_ACCEPTED: 'Kabul edildi',
  cancellation_request_status_REJECTED: 'Reddedildi',
  cancellation_request_status_WITHDRAWN: 'Geri çekildi',
  cancellation_request_status_ESCALATED: 'Anlaşmazlığa taşındı',
  cancellation_request_status_LAPSED: 'Süresi doldu',
  dispute_status_OPEN: 'Açık',
  dispute_status_IN_REVIEW: 'İncelemede',
  dispute_status_ESCALATED: 'Üst kademeye taşındı',
  dispute_status_RESOLVED: 'Çözüldü',
  dispute_outcome_CANCEL_WORK: 'İş iptal edildi',
  dispute_outcome_KEEP_WORK: 'İş devam ediyor',
  guilty_side_CUSTOMER: 'Müşteri',
  guilty_side_EXECUTOR: 'Yüklenici',
  guilty_side_NONE: 'Kusurlu yok',
  dispute_author_customer: 'Müşteri',
  dispute_author_executor: 'Yüklenici',
  dispute_author_support: 'Destek',
  work_card_file_uploading: 'Dosya yükleniyor…',
  nav_label: 'Bölümler',
  nav_toggle: 'Menü',
  nav_sign_out: 'Çıkış yap',
  nav_group_works: 'İşler',
  nav_group_cargo: 'Yükler',
  nav_group_fleet: 'Filo',
  nav_group_money: 'Para',
  nav_group_company: 'Şirket',
  works_column_status: 'Durum',
  works_column_route: 'Güzergâh',
  works_column_cargo: 'Yük',
  works_column_loading: 'Yükleme',
  works_column_vehicle: 'Araç',
  works_column_driver: 'Sürücü',
  works_column_action: 'İşlem',

  // Блок `WEB-3.5`: внутренний заказ.
  works_internal_new: 'Yeni iç sipariş',
  internal_work_form_title: 'İç sipariş',
  internal_work_form_weight: 'Ağırlık, kg',
  internal_work_form_submit: 'Sipariş oluştur',
  work_internal: 'İç sipariş',
  work_card_internal_cancel: 'Siparişi iptal et',
  work_card_internal_cancel_send: 'Bu nedenle iptal et',
  work_card_internal_cancel_question: 'Sipariş iptal edilsin mi? İş iptal edilecek ve geri alınamaz.',
};
